<!-- 红色印记·英雄丰碑 -->
<template>
  <div class="component-news-list">
    <div class="all-content">
      <div class="title">
        <div class="bigtitle">
          <span class="titlestyle">红色印记·</span>英雄丰碑
        </div>
      </div>
      <div class="bigimg">
        <!-- <div class="top-map">
          <div class="map">
            <div class="box">
              <div class="china-map-img"></div>
              <div
                id="china-map"
                style="width:1100px;height:577px;display:inline-block;text-align: center"
              ></div>
            </div>
          </div>
        </div> -->
        <div align="center" class="ditu" style="">
          <img
            src="../assets/images/map.png"
            alt=""
            srcset=""
            @click="jnss()"
          />
          <!-- <button>立即查看</button> -->
          <!-- <div class="h5box"> -->
          <!-- <iframe
            src="http://yinglie.chinamartyrs.gov.cn/LingYuanZhanShi/lingyuan/index-map.html"
            frameborder="0"
            scrolling="no"
            width="1140px"
            height="1100px"
            style="margin-left:-150px;"
          ></iframe> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComponentNewsList",
  props: {},
  methods: {
    jnss() {
      window.open("http://www.chinamartyrs.gov.cn/x_jnss/");
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
/* .ditu {
  height: 800px;
  background-image: url(../assets/images/map.png);
  background-size: 100%;
} */
.ditu button {
  background-color: var(--main-color);
  border: 0;
  color: #fff;
  position: relative;
  font-size: 16px;
  margin-top: 30px;
  left: -60px;
  padding: 8px 30px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.9);
  transition: all 0.4s;
}
.ditu .ditus {
  width: 1300px;
  height: 100%;
}
.ditu .h5box {
  width: 100%;
  height: 100%;
  margin-top: 30px;
}
.ditu img {
  cursor: pointer;
  width: 1140px;
}
.component-news-list {
  width: 1200px;
  min-width: 1200px;
  height: 930px;
  background-color: rgb(255, 255, 255);
  border-radius: 15px;
  margin-top: 12px;
}
.all-content {
  width: 1140px;
  height: 930px;
  position: relative;
  margin: 0 auto;
  top: 10px;
}
.title,
.bigimg {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.title {
  line-height: 15px;
}
.bigimg {
  height: 850px;
  top: 50px;
  overflow: hidden;
  /* background: url(../assets/images/mapimg.jpg); */
  background-size: 120%;
  background-position-x: right;
}

/*地图整体*/
.top-map {
  width: 100%;
  text-align: center;
}
.backimg {
  background-image: url("../assets/img/img/mapimg.jpg");

  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.china-map-img {
  width: 351px;
  height: 40px;
  font-size: 30px;
  font-weight: 700;
  background-image: url("../assets/img/img/jnss-map-title.png");
  background-size: 100% 100%;
  position: absolute;
  left: 25px;
  top: 65px;
  z-index: 500;
}
.map {
  background-color: rgba(0, 0, 0, 0);
  width: 100%;
  height: 100%;
  text-align: center;
}
.box {
  width: 1100px;
  height: 100%;
  text-align: center;
  position: relative;
  display: inline-block;
}

.top-map > div {
  width: 100%;
}
/*地图数据分析*/
.top-map > .data {
  height: 140px;
  border-bottom: 1px solid #ddd;
  box-sizing: border-box;
  margin-top: 38px;
}
.data > div {
  position: relative;
  width: 25%;
  height: 100%;
  padding-top: 22px;
  padding-left: 8px;
  float: left;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  box-sizing: border-box;
  cursor: pointer;
}
.data > .Select {
  background-color: #ffe0e0;
}
.data > div:nth-child(1):hover {
  background-color: #ffe0e0 !important;
}
.data > div:nth-child(2):hover {
  background-color: #b1d4ef !important;
}
.data > div:nth-child(3):hover {
  background-color: #fbcdaf !important;
}
.data > div:nth-child(4):hover {
  background-color: #d8f1c7 !important;
}
.list > table th:nth-child(2),
.list > table th:nth-child(3) {
  text-align: center !important;
}

.data > div:nth-child(1) {
  border-top: 6px solid #fd4d4d;
}
.data > div:nth-child(2) {
  border-top: 6px solid #52b4ff;
}
.data > div:nth-child(3) {
  border-top: 6px solid #ff9855;
}
.data > div:nth-child(4) {
  border-top: 6px solid #4fc202;
}
.data > div > .data-title > .Facilityidentification {
  font-weight: 700;
  font-size: 18px !important;
  color: #333333 !important;
}

.data > div:nth-child(1) > .data-title > h3 {
  color: #fd4d4d;
}
.data > div:nth-child(1) > .data-title > .Facilityidentification {
  font-size: 24px;
  color: #fd4d4d;
}
.data > div:nth-child(2) > .data-title > h3 {
  color: #52b4ff;
}
.data > div:nth-child(2) > .data-title > .Facilityidentification {
  font-size: 24px;
  color: #52b4ff;
}
.data > div:nth-child(3) > .data-title > h3 {
  color: #ff9855;
}
.data > div:nth-child(3) > .data-title > .Facilityidentification {
  font-size: 24px;
  color: #ff9855;
}
.data > div:nth-child(4) > .data-title > h3 {
  color: #4fc202;
}
.data > div:nth-child(4) > .data-title > .Facilityidentification {
  font-size: 24px;
  color: #4fc202;
}

.jqm-round-sector {
  position: absolute;
  left: 0;
  top: 0;
}
.jqm-round-wrap {
  float: left;
  width: 115px !important;
  height: 115px !important;
}
.jqm-round-wrap > canvas {
  cursor: default !important;
}
.jqm-round-bg {
  width: 115px !important;
  height: 115px !important;
}

.jqm-round-circle p {
  line-height: 80px !important;
}
.data-title {
  float: left;
  width: 147px;
  height: 115px;
  position: relative;
}
.data-title .Facilityidentification {
  font-size: 16px;
  margin-bottom: 10px;
}
.data-title h3 {
  position: absolute;
  left: 50%;
  margin-left: -73.5px;
  top: 45px;
  font-size: 24px;
  margin-bottom: 10px;
  width: 100%;
}
.data-title p.Proportion {
  font-size: 14px;
  position: absolute;
  bottom: 5px;
  /*left: 50%;
                transform: translateX(-50%);*/
  width: 100%;
}
.content .data {
  box-shadow: 0px 2px 9px 0px #d3d3d3;
  height: 161px;
}
</style>



// WEBPACK FOOTER //
// src/components/fengbei.vue